import availableSubscriptionDictionary from '../../ru/available-subscription/available-subscription.dic.json';

export const availableSubscriptionNS = {
  AVAILABLE_SUBSCRIPTION: availableSubscriptionDictionary,
};

export const availableSubscriptionNamespaces = ['AVAILABLE_SUBSCRIPTION'];
